// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-big {
  font-weight: 700;
  font-size: 17px;
  line-height: 1.2;
  white-space: nowrap;
}
.home-topup {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: var(--v2-primary);
  color: #fff !important;
  align-self: flex-end;
  margin-bottom: 1px;
  flex: none;
}
.home-topup:hover {
  background: #374151;
}
.home-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.home-section-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}
.home-asst {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}
.home-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
}
.home-channels {
  display: flex;
  gap: 5px;
}
.home-ch {
  position: relative;
  width: 26px;
  height: 26px;
  border-radius: 7px;
  border: 1px dashed var(--v2-border);
  color: #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.home-ch.is-on {
  border: 0;
  background: var(--v2-hover);
  color: var(--v2-primary);
}
.home-max {
  font-size: 8.5px;
  font-weight: 800;
  letter-spacing: 0.02em;
}
.home-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 16px;
  align-items: start;
}
.home-list {
  display: flex;
  flex-direction: column;
}
.home-step {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 9px 0;
  border-top: 1px solid var(--v2-border-soft);
}
.home-check {
  width: 20px;
  height: 20px;
  flex: none;
  border-radius: 50%;
  border: 1.5px solid #d1d5db;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-check.is-done {
  border: 0;
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
}
.home-step-done {
  flex: 1;
  color: var(--v2-muted);
  text-decoration: line-through;
  font-size: 13px;
}
.home-dialog {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-top: 1px solid var(--v2-border-soft);
  font-size: 13px;
  color: var(--v2-primary);
}
.home-dialog-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home-unanswered {
  color: var(--v2-orange);
  font-weight: 600;
}
.home-empty {
  padding: 22px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/home.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,OAAO;EACP,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV","sourcesContent":[".home-big {\n  font-weight: 700;\n  font-size: 17px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n.home-topup {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  background: var(--v2-primary);\n  color: #fff !important;\n  align-self: flex-end;\n  margin-bottom: 1px;\n  flex: none;\n}\n.home-topup:hover {\n  background: #374151;\n}\n.home-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.home-section-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n}\n.home-asst {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n}\n.home-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  font-size: 13px;\n  white-space: nowrap;\n}\n.home-channels {\n  display: flex;\n  gap: 5px;\n}\n.home-ch {\n  position: relative;\n  width: 26px;\n  height: 26px;\n  border-radius: 7px;\n  border: 1px dashed var(--v2-border);\n  color: #d1d5db;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n.home-ch.is-on {\n  border: 0;\n  background: var(--v2-hover);\n  color: var(--v2-primary);\n}\n.home-max {\n  font-size: 8.5px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n.home-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n  gap: 16px;\n  align-items: start;\n}\n.home-list {\n  display: flex;\n  flex-direction: column;\n}\n.home-step {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 9px 0;\n  border-top: 1px solid var(--v2-border-soft);\n}\n.home-check {\n  width: 20px;\n  height: 20px;\n  flex: none;\n  border-radius: 50%;\n  border: 1.5px solid #d1d5db;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.home-check.is-done {\n  border: 0;\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n}\n.home-step-done {\n  flex: 1;\n  color: var(--v2-muted);\n  text-decoration: line-through;\n  font-size: 13px;\n}\n.home-dialog {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 0;\n  border-top: 1px solid var(--v2-border-soft);\n  font-size: 13px;\n  color: var(--v2-primary);\n}\n.home-dialog-text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.home-unanswered {\n  color: var(--v2-orange);\n  font-weight: 600;\n}\n.home-empty {\n  padding: 22px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
